export const SET_SIDENAV_VISIBILITY = "SET_SIDENAV_VISIBILITY";
export const SET_SIDENAV_MINI_VARIANT = "SET_SIDENAV_MINI_VARIANT";
export const SET_SIDENAV_ACTIVE_MENU_STYLE = "SET_SIDENAV_ACTIVE_MENU_STYLE";
export const SET_SIDENAV_POSITION_TO_RIGHT = "SET_SIDENAV_POSITION_TO_RIGHT";

export const SET_HEADER_VISIBILITY = "SET_HEADER_VISIBILITY";
export const SET_HEADER_CLIPPED_OVER = "SET_HEADER_CLIPPED_OVER";
export const UPDATE_HEADER_SETTING = "UPDATE_HEADER_SETTING";

export const SET_LOCALE = "SET_LOCALE";
export const SET_CURRENCY = "SET_CURRENCY";
export const SET_AVATAR = "SET_AVATAR";

export const SET_FOOTER_VISIBILITY = "SET_FOOTER_VISIBILITY";
export const SET_APP_FOOTER = "SET_APP_FOOTER";
export const SET_FIXED_FOOTER = "SET_FIXED_FOOTER";
export const SET_INSET_FOOTER = "SET_INSET_FOOTER";
export const SET_ABSOLUTE_FOOTER = "SET_ABSOLUTE_FOOTER";
export const SET_PADLESS_FOOTER = "SET_PADLESS_FOOTER";

export const SET_PRIMARY_COLOR = "SET_PRIMARY_COLOR";
export const SET_SECONDARY_COLOR = "SET_SECONDARY_COLOR";
export const SET_HEADER_COLOR = "SET_HEADER_COLOR";
export const SET_FOOTER_COLOR = "SET_FOOTER_COLOR";
export const SET_DARK_MODE = "SET_DARK_MODE";
export const SET_SEMI_DARK_MODE = "SET_SEMI_DARK_MODE";
export const SET_RTL = "SET_RTL";

export const SET_USER = "SET_USER";
export const SET_DATE = "SET_DATE";
export const SET_SETTINGS = "SET_SETTINGS";
export const SET_ORDERS = "SET_ORDERS";
export const SET_STATUS = "SET_STATUS";
export const SET_CARRIERS = "SET_CARRIERS";
export const SET_DEPOS = "SET_DEPOS";
export const SET_ACTIVE_CARRIERS = "SET_ACTIVE_CARRIERS";
export const SET_ACTIVE_STATUS = "SET_ACTIVE_STATUS";
export const SYNCHRO = "SYNCHRO";
export const TOGGLE_SPEND_MODAL = "TOGGLE_SPEND_MODAL";
export const SET_USER_CREDITS="SET_USER_CREDITS";
export const SET_TIMEFRAME="SET_TIMEFRAME";
export const SET_MONTH_TIMEFRAME="SET_MONTH_TIMEFRAME";
export const SET_MODAL="SET_MODAL";
export const SET_FIXINGS="SET_FIXINGS";
export const SET_EBAY_ACCOUNTS="SET_EBAY_ACCOUNTS";
export const SET_PLAFOND="SET_PLAFOND";
export const SET_DESTINATIONS="SET_DESTINATIONS";
export const SET_MESSAGESCOUNT="SET_MESSAGESCOUNT";
export const SET_NEW_BOOKINGS_ALERT="SET_NEW_BOOKINGS_ALERT";
export const SET_TEMP_BRAND="SET_TEMP_BRAND";
export const SET_DISABLE_SAME_DAY_BOOKING="SET_DISABLE_SAME_DAY_BOOKING";
export const SET_PUSH_SUBSCRIBED="SET_PUSH_SUBSCRIBED";
export const SET_PUSH_TBM="SET_PUSH_TBM";
export const SET_TBM="SET_TBM";